import React, {Component} from 'react';
import PropTypes from "prop-types";
import Slider from 'react-slick';
import {Link} from "react-router-dom";
import {Pie} from 'react-chartjs-2';
import scrollToComponent from 'react-scroll-to-component';
import moment from 'moment';
import placeholder from '../../assets/videoImgs/thumbshot1.jpg';
import PieChart from 'react-minimal-pie-chart';
import { Scrollbars } from 'react-custom-scrollbars';
import api from '../../utils/api';
import LectureTile from './LectureTile';
import LoadingTile from './LoadingTile';
import Counter from '../Dashboard/DashboardUser/Counter';
import '../../video.css?v=1.0';
import { SSL_OP_SSLEAY_080_CLIENT_DH_BUG } from 'constants';
import testBanner from '../../assets/img/test-banner.jpeg';

/* global $ */

class Video extends Component {

    constructor(props){
        super(props);

        this.state = {
            show: false,
            shakeBlockVideo: "disabled-course-click",
            courseClassName: '',
            el: null,
            currentUser: null,
            currentChapter: null,
            currentChapterPart: null,
            currentChapterTest: false,
            completedSubject: false,
            loaded: false,
            showLectureDetails: -1,
            showLecturePartDetails: -1,
            chapterTime: 0,
            timeLeft: -1,
            timeTaken: -1,
            timerId: null
        };

        this.timer = null;
    }

    //Actions
    handleChangeShake = (index) => {
        this.setState({
            el: index,
            courseClassName: "disabled-course-click"
        });
        setTimeout(() => {
            this.setState({
                courseClassName: ''
            })
        }, 500);
    };

    detailsInfo = (item) => {
        this.setState({show: true});
        this.props.videoGallery.map((element) => {
            element.isShow = false;
            if (element === item) {
                return element.isShow = true;
            }else{
                return null;
            }
        });
    };

    closeDetails = () => {
        this.props.videoGallery.map((element) => {
            return element.isShow = false;
        });
        this.setState({show: false})
    };

    handleVideoItemClick = (index) => {
        this.handleChangeShake(index);
        setTimeout(() => {
            scrollToComponent(this.VideoDescriptionAccardion, { offset: 0, align: 'top', duration: 500, ease:'inExpo'});
        }, 400);
    };

    handleMainResumeBtn = () => {
        this.setState({
            show: true
        });
        setTimeout(() => {
            scrollToComponent(this.VideoDescriptionAccardion, { offset: 0, align: 'top', duration: 650, ease:'inExpo'});
        }, 400);

        const videoGalleryCurrentItemIndex = () => (
            this.props.videoGallery.map((item, index) => {
                if (item.isActive && !item.isComplete) {
                    this.setState({
                        el: index,
                    });
                }
                
                return true;
            })
        );

        videoGalleryCurrentItemIndex();
    };

    //Lifecycle methods
    componentDidMount() {

        this.props.onLoad(this.props.user.user.Profile.id, this.props.match.params.name, this.props.match.params.courseId, this.props.user.id);
        if(this.props.userSubject.id){
            this.props.getCompletedUserLectures(this.props.userSubject.id, this.props.user.id);
        }

        if(this.props.courseUser[0].id && this.props.userSubject){
            if(this.props.userSubject.courseSubjectId !== this.props.match.params.name){
                return false;
            }

                if(this.props.userSubject.type === "review"){
                    this.props.history.push('/my-tests/review');
                }
                
                
                if(!this.state.timerId){

                    let secondsLeft = moment.duration(moment(new Date(this.props.courseUser[0].currentSubjectDeadline)).diff(moment())).as('seconds');
                    let timeTaken = moment.duration(new Date() - new Date(this.props.courseUser[0].currentSubjectStart)).as('seconds');
                    

                    this.setState({setTimer: true, timeLeft: secondsLeft, timeTaken: timeTaken});


                    
                }
                if (this.props.courseUser && this.props.userSubject.Subject) {
                    let currentUser = this.props.courseUser.filter(cu => cu.courseId === this.props.userSubject.Subject.courseId)[0];
                    let currentChapter;
                    let currentChapterPart;
                    let currentChapterTest = false;

                    if(currentUser) {

                        try {
                            if(currentUser.currentChapter){
                                currentChapter = this.props.userSubject.Subject.CourseChapter.filter(ch => ch.id === currentUser.currentChapter)[0];
                            }else{
                                //manually set chapter/part
                                
                                currentChapter = this.props.userSubject.Subject.CourseChapter[0];
                                currentChapterPart = this.props.userSubject.Subject.CourseChapter[0].ChapterVideo[0];
                            }
                        }catch(err) {

                           

                                currentChapter = this.props.userSubject.Subject.CourseChapter.sort(function (a, b) {
                                    return (a.number > b.number) ? 1 : ((b.number > a.number) ? -1 : 0)
                                })[0];

                            
                        }


                        if (currentChapter) {

                            if (this.props.ul.filter(l =>  l.completed && l.active).length > 0) {
                                let relevant = this.props.ul.filter(l =>  l.completed && l.active).filter(p => p.subjectChapterId === currentChapter.id);

                                currentChapterPart = currentChapter.ChapterVideo.sort(function(a,b) {
                                    return (a.number > b.number) ? 1 : ((b.number > a.number) ? -1 : 0)
                                })[relevant.length];

                                if (!currentChapterPart) {
                                    let c = this.props.userSubject.Subject.CourseChapter.sort(function(a,b) {
                                        return (a.number > b.number) ? 1 : ((b.number > a.number) ? -1 : 0)
                                    })[0];
                                    if (c) {
                                        c.completedOn = new Date();
                                    } else {
                                        if (!this.state.completedSubject) {

                                            let alreadyCompletedSubject = currentUser.UserSubject.filter(s => s.active && s.completed && s.courseSubjectId === this.props.userSubject.courseSubjectId);
                                            if (alreadyCompletedSubject.length === 0) {
                                                let Sub = this.props.userSubject;
                                                Sub.completedOn = new Date();
                                                currentUser.completedSubjects.push(Sub);
                                            }

                                        }
                                    }


                                }
                            } else {

                                this.props.userSubject.Subject.CourseChapter.map(chapter => {
                                    if(chapter.ChapterVideo){
                                        chapter.ChapterVideo.map(vid => {
                                            if(vid.id === currentUser.currentChapterPart){
                                                currentChapterPart = vid;
                                                return true;
                                            }
                                        })
                                    }
                                })
                            }
                        } else {
                            currentChapter = this.props.userSubject.Subject.CourseChapter[0];

                            let completed = false; //this.props.userSubject.Subject.CourseChapter[0];

                            if (completed === 2) {
                                let c = this.props.userSubject.Subject.CourseChapter[0];
                                c.completedOn = new Date();
                               
                            } else if(completed === 4){
                                let alreadyComplete = currentUser.UserSubject.filter(s => s.active && s.completed && s.courseSubjectId === this.props.userSubject.courseSubjectId);
                                if (alreadyComplete.length > 0) {
                                    this.setState({completedSubject: true});

                                } else {
                                    let Sub = this.props.userSubject;
                                    Sub.createdOn = new Date();
                                    currentUser.completedSubjects.push(Sub);
                                    
                                    this.setState({completedSubject: true});
                                }

                            }
                        }

                        let chapterTime = 0;
                        if(currentUser){
                            let st = moment(currentUser.currentChapterStarted);
                            let now = moment(new Date());
                            chapterTime = now.diff(st, 'seconds');
                        }

                        this.setState({
                            currentUser,
                            currentChapter,
                            currentChapterPart,
                            chapterTime,
                            currentChapterTest,
                            loaded: true
                        })
                    }

                }

            
        }
    }

    unFocusDetils = () => {
        this.setState({showLectureDetails: -1, showLecturePartDetails: -1});
    }

    componentDidUpdate(props){
        if(props.match.params.name !== this.props.match.params.name){

            this.setState({
                currentUser: null,
                currentChapter: null,
                currentChapterPart: null,
                loaded: false,
                completedSubject: false,
                showLectureDetails: -1,
                showLecturePartDetails: -1
            }, () => {
                this.props.onLoad(this.props.profile.id, this.props.match.params.name, this.props.profile.CourseUser[0].courseId, this.props.user.id);
            })
        }

            if ((props.courseUser !== this.props.courseUser || props.userSubject !== this.props.userSubject) && this.props.courseUser.length > 0) {
                if(this.props.userSubject.type === "review"){
                    this.props.history.push('/my-tests/review');
                }
                
                
                if(!this.state.timerId){

                    let secondsLeft = moment.duration(moment(new Date(this.props.courseUser[0].currentSubjectDeadline)).diff(moment())).as('seconds');
                    let timeTaken = moment.duration(new Date() - new Date(this.props.courseUser[0].currentSubjectStart)).as('seconds');
                    

                    this.setState({setTimer: true, timeLeft: secondsLeft, timeTaken: timeTaken});


                    
                }
                if (this.props.courseUser && this.props.userSubject.Subject) {
                    let currentUser = this.props.courseUser.filter(cu => cu.courseId === this.props.userSubject.Subject.courseId)[0];
                    let currentChapter;
                    let currentChapterPart;
                    let currentChapterTest = false;

                    if(currentUser) {

                        try {
                            if(currentUser.currentChapter){
                                currentChapter = this.props.userSubject.Subject.CourseChapter.filter(ch => ch.id === currentUser.currentChapter)[0];
                            }else{
                                //manually set chapter/part
                                
                                currentChapter = this.props.userSubject.Subject.CourseChapter[0];
                                currentChapterPart = this.props.userSubject.Subject.CourseChapter[0].ChapterVideo[0];
                            }
                        }catch(err) {

                           

                                currentChapter = this.props.userSubject.Subject.CourseChapter.sort(function (a, b) {
                                    return (a.number > b.number) ? 1 : ((b.number > a.number) ? -1 : 0)
                                })[0];

                            
                        }


                        if (currentChapter) {

                            if (this.props.ul.filter(l =>  l.completed && l.active).length > 0) {
                                let relevant = this.props.ul.filter(l =>  l.completed && l.active).filter(p => p.subjectChapterId === currentChapter.id);

                                currentChapterPart = currentChapter.ChapterVideo.sort(function(a,b) {
                                    return (a.number > b.number) ? 1 : ((b.number > a.number) ? -1 : 0)
                                })[relevant.length];

                                if (!currentChapterPart) {
                                    let c = this.props.userSubject.Subject.CourseChapter.sort(function(a,b) {
                                        return (a.number > b.number) ? 1 : ((b.number > a.number) ? -1 : 0)
                                    })[0];
                                    if (c) {
                                        c.completedOn = new Date();
                                    } else {
                                        if (!this.state.completedSubject) {

                                            let alreadyCompletedSubject = currentUser.UserSubject.filter(s => s.active && s.completed && s.courseSubjectId === this.props.userSubject.courseSubjectId);
                                            if (alreadyCompletedSubject.length === 0) {
                                                let Sub = this.props.userSubject;
                                                Sub.completedOn = new Date();
                                                currentUser.completedSubjects.push(Sub);
                                            }

                                        }
                                    }


                                }
                            } else {

                                this.props.userSubject.Subject.CourseChapter.map(chapter => {
                                    chapter.ChapterVideo.map(vid => {
                                        if(vid.id === currentUser.currentChapterPart){
                                            currentChapterPart = vid;
                                            return true;
                                        }
                                    })
                                })
                            }
                        } else {
                            currentChapter = this.props.userSubject.Subject.CourseChapter[0];

                            let completed = false; //this.props.userSubject.Subject.CourseChapter[0];

                            if (completed === 2) {
                                let c = this.props.userSubject.Subject.CourseChapter[0];
                                c.completedOn = new Date();
                               
                            } else if(completed === 4){
                                let alreadyComplete = currentUser.UserSubject.filter(s => s.active && s.completed && s.courseSubjectId === this.props.userSubject.courseSubjectId);
                                if (alreadyComplete.length > 0) {
                                    this.setState({completedSubject: true});

                                } else {
                                    let Sub = this.props.userSubject;
                                    Sub.createdOn = new Date();
                                    currentUser.completedSubjects.push(Sub);
                                    
                                    this.setState({completedSubject: true});
                                }

                            }
                        }

                        let chapterTime = 0;
                        if(currentUser){
                            let st = moment(currentUser.currentChapterStarted);
                            let now = moment(new Date());
                            chapterTime = now.diff(st, 'seconds');
                        }

                        this.setState({
                            currentUser,
                            currentChapter,
                            currentChapterPart,
                            chapterTime,
                            currentChapterTest,
                            loaded: true
                        })
                    }

                }

            }

    }

    //Renders
    renderVideoPgHeader = () => {
        const data = {
            labels: [
                'Completed',
                'Remaing'
            ],
            datasets: [{
                data: [30, 70],
                backgroundColor: [
                    '#0376b2',
                    '#ff851b'
                ],
                hoverBackgroundColor: [
                    '#0376b2',
                    '#ff851b'
                ]
            }]
        };
        return (
            <div className="bg-light lter b-b wrapper-md">
                <div className="row">
                    <div className="col-sm-6 col-xs-6">
                        <h1 className="m-n font-thin h3 text-black">
                            MCAT
                        </h1>
                        <small className="text-muted">
                            Admin Panel
                        </small>
                    </div>
                    <div className="col-sm-6 col-xs-6">
                        <div className="pull-right">
                            <div className="pull-left sp-right20">
                                <p className="sm-bottom0">
                                    Remaining:
                                    <span style={{color: "#00c152"}}>
                                            2 Hours
                                        </span>
                                </p>
                                <p>Total Time::
                                    <span style={{color: "#0a6be4"}}>
                                            8 Hours
                                        </span>
                                </p>
                            </div>
                            <div className="pull-left">
                                <div id="demo-sparkline-pie-2"/>
                                <Pie
                                    data={data}
                                    width={50}
                                    height={50}
                                    options={{
                                        maintainAspectRatio: false,
                                        legend: {
                                            display: false,
                                        },
                                        tooltips: {
                                            enabled: false
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    renderMainVideoDescription = () => (
        <div className="sm-bottom20 wow fadeIn">
            <div className="videoDescWrapper main- video-preview-wrapper">
                <div className="videoDesc main-video-preview">
                    {/*<img src={BackgroundImage} alt=""/>*/}
                    <img src='http://webworldpk.com/demo/99point9/assets/videos/5.jpg' alt="Video" />
                    <div className="row video-main-preview-resume">
                        <div className="sm-top-bottom40  wow bounceInUp"
                             data-wow-delay='1.9s'>
                            {/*<Link*/}
                                {/*to={'/video/physics/id'}*/}
                                {/*className="btn btn-danger btn-block"*/}
                                {/*onClick={this.closeDetails}*/}
                            {/*>*/}
                                {/*<i className="zmdi zmdi-play"/>*/}
                                {/*Resume*/}
                            {/*</Link>*/}
                            <button
                                className="btn btn-danger btn-block"
                                onClick={this.handleMainResumeBtn}
                            >
                                <i className="zmdi zmdi-play"/>
                                Resume
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    renderLectureGoals = () => {
        return this.props.videoDescription.goals.map((item, index) => (
            <li key={index}>
                <i className={
                    item.points === 0
                        ? item.icoClass + ' bounce'
                        : item.icoClass
                    }
                />
                {item.text}
                {
                    item.points >= 0 &&
                    <span className={`badge badge-${item.pointsType}`}>
                        {item.points}
                    </span>
                }
            </li>
        ))
    };

    renderVideosSlider = () => {
        let settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 1,
            vertical: false,
            arrows: true,
            centerPadding: '50px'
        };
        return (
            <Slider {...settings}>
                {this.renderVideos()}
            </Slider>
        )
    };

    renderVideos = () => {
        return this.props.videoGallery.map((item, index) => {

            return (
                <div
                    className={"video-item "
                    + (item.isShow
                        ? " videoDescTriangle"
                        : ''+ (item.isActive
                            ? (!item.isComplete &&
                                    (this.state.show
                                        ? (this.state.el === index)
                                                ? ' videoDescTriangle active-video-wrapper'
                                                : ' active-video-wrapper'
                                        : ' active-video-wrapper'
                                    )
                                )
                            : (this.state.el === index
                                ? this.state.courseClassName
                                : '')
                            )
                        )
                    }
                    key={index}
                    style={{padding: "10px"}}
                    onClick={() => this.handleVideoItemClick(index)}
                >
                    <div
                        className={"video-item "
                        + (item.isActive
                            ? item.isComplete
                                ? "completed-video"
                                : "active-video"
                            : "video-locked"
                        )}
                    >
                        <i className={(
                            item.isActive
                                ? item.isComplete
                                    ? "zmdi zmdi-check-circle"
                                    : "zmdi zmdi-"
                                : "glyphicon glyphicon-lock"
                        )}/>
                        <Link
                            to="#"
                            onClick={() => {
                                this.detailsInfo(item)
                            }}
                        >
                            <img src={item.image} alt="Video" />
                        </Link>
                        <div
                            className="completedPercentage"
                            style={{width: `${item.progress + '%'}`}}
                        >
                        </div>
                        <p>
                            <Link to="#">
                                {item.title}
                            </Link>
                        </p>
                    </div>
                </div>
            )
        })
    };

    renderVideoDescription = () => (
        <div
            className="videoDescWrapper videoDescPopUp"
            ref={(div) => { this.VideoDescriptionAccardion = div; }}
        >
            {this.state.show &&
            <div className="videoDesc">
                <Link
                    to="#"
                    className="closeDesc"
                    onClick={this.closeDetails}
                >
                    <i className="zmdi zmdi-close"/>
                </Link>
                <h3>
                    Some table of contents
                </h3>
                <div className="row">
                    <div className="col-sm-4">
                        <div className="sp-top20">
                            <h2 className="sm-top0 sm-bottom10">
                                Lecture Goals
                            </h2>
                            <ul className="list-unstyled lecture-goals">
                                {this.renderVideoDescriptionGoals()}
                            </ul>
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="sp-top20 text-center">
                            <h2 className="sm-top0 sm-bottom10">
                                Merits Earned
                            </h2>
                            <h4 className="sm-top-bottom0"
                                style={{fontSize: "150px"}}>
                                {this.props.videoDescription.meritsEarned}
                            </h4>
                        </div>
                    </div>
                </div>
                {this.renderVideoDescriptionBtns()}
            </div>
            }
        </div>
    );

    renderVideoDescriptionGoals = () => {
        return this.props.videoDescription.goals.map((item, index) => (
            <li key={index}>
                <i className={item.icoClass}/>
                {item.text}
                {
                    item.points >= 0 &&
                    <span className={`badge badge-${item.pointsType}`}>
                        {item.points}
                    </span>
                }
            </li>
        ))
    };

    renderVideoDescriptionBtns = () => (
        <div className="desc-controls">
            <Link
                to={'/video/physics/id'}
                className="btn btn-danger btn-block"
                onClick={this.closeDetails}
            >
                <i className="zmdi zmdi-play"/>
                Resume
            </Link>

        </div>
    );

    renderView = ({ style, ...props }) =>{
        const { top } = this.state;
        const viewStyle = {
            
            background: 'transparent',
            color: '#aaa'
        };
        return (
            <div
                className="box"
                style={{ ...style, ...viewStyle }}
                {...props}/>
        );
    }

    renderThumb = ({ style, ...props }) => {
        const { top } = this.state;
        const thumbStyle = {
            backgroundColor: `rgba(255,255,255,.2)`
        };
        return (
            <div
                className="rail"
                style={{ ...style, ...thumbStyle }}
                {...props}/>
        );
    }
    
    mapChapterVideos = (videos, chapterIndex, current) => {
        // completed-video, video-locked
        let {currentUser, currentChapterPart} = this.state;



        return videos.map((vid, i) => {
            let videoClass, iconClass;

            let completed = vid.UserLecture.filter(p => p.completed === true);
            let activeLength = vid.UserLecture.filter(p => p.active === true);


            if(currentChapterPart) {
                if(this.props.user.user.role === 'admin'){
                    iconClass = 'zmdi zmdi-play-circle';
                    videoClass = 'admin-video';
                }else if (completed.length > 0) {
                    videoClass = 'completed-video';
                    iconClass = 'zmdi zmdi-check-circle';
                }else if (activeLength.length > 0) {
                    iconClass = 'zmdi zmdi-play-circle';
                    videoClass = 'active-video';
                } else if (currentUser.currentChapterPart === vid.id) {
                    iconClass = 'zmdi zmdi-play-circle';
                    videoClass = 'active-video';
                } else if (this.props.courseUser[0].courseCompleted && currentUser.currentChapterPart !== vid.id) {
                    iconClass = 'zmdi zmdi-play-circle';
                    videoClass = 'admin-video';
                }else{
                    videoClass = 'video-locked';
                }
            }else{
                videoClass = 'completed-video';
                iconClass = 'zmdi zmdi-check-circle';
            }

            if(vid.VideoFile){
                if(vid.VideoFile.length > 0){
                    return <LectureTile
                        key={i}
                        lecture={vid}
                        videoClass={videoClass}
                        iconClass={iconClass}
                        history={this.props.history}
                        chapterIndex={chapterIndex}
                        lectureIndex={i}
                        showLecturePartDetails={this.state.showLecturePartDetails}
                        showLectureDetails={this.state.showLectureDetails}
                        user={this.props.user}
                    />
                }else if(vid.type === "test"){
                    return <LectureTile
                            key={i}
                            lecture={vid}
                            videoClass={videoClass}
                            iconClass={iconClass}
                            history={this.props.history}
                            chapterIndex={chapterIndex}
                            lectureIndex={i}
                            showLecturePartDetails={this.state.showLecturePartDetails}
                            showLectureDetails={this.state.showLectureDetails}
                            user={this.props.user}
                        />
                }else{
                    return null;
                }
            }else if(vid.type === "test"){
                return <LectureTile
                        key={i}
                        lecture={vid}
                        videoClass={videoClass}
                        iconClass={iconClass}
                        history={this.props.history}
                        chapterIndex={chapterIndex}
                        lectureIndex={i}
                        showLecturePartDetails={this.state.showLecturePartDetails}
                        showLectureDetails={this.state.showLectureDetails}
                        user={this.props.user}
                    />
            }else{
                return null;
            }
            
        })
    }

    mapLoadingTiles = () => {
        
        return (
            <div>
                <LoadingTile step={0} />
                <LoadingTile step={1} />
                <LoadingTile step={2} />
                <LoadingTile step={3} />
                <LoadingTile step={4} />
                <LoadingTile step={5} />
            </div>
        )
        
    }

    mapChapterParts = (subject) => {
        let {currentChapter, currentUser} = this.state;


        return (

            subject.Subject.CourseChapter.sort(function(a,b) {
                return (a.number > b.number) ? 1 : ((b.number > a.number) ? -1 : 0)
            }).map((chapter, i) => {

                let completed = [];

                let done = completed.length > 0;
                let beatLectureTime = false;
                let points = 0;

                if(this.props.chapterPart){


                    let completedLecture = this.props.ul.filter(l => l.chapterVideoId === this.props.chapterPart.id && l.completed && l.active);


                        if (completedLecture.length > 0) {
                            if(this.props.chapterPart.finish) {
                                if (completedLecture[0].userTime < this.props.chapterPart.finish) {
                                    beatLectureTime = true;
                                }
                            }

                            points += completedLecture[0].points;
                        }


                }

                let videoClass = '';
                if(chapter.type === "test"){


                    let completed = currentUser.completedChapters.filter(p => p.id === chapter.id);

                    if(currentChapter) {
                        if (completed.length > 0) {
                            videoClass = 'completed-video';
                        } else if (currentChapter.id === chapter.id) {
                            videoClass = 'active-video';
                        } else {
                            videoClass = 'video-locked';
                        }
                    }else{
                        videoClass = 'completed-video';
                    }
                }


                return (
                    <div key={i} className="chapter-panel-wrapper ch-<?php echo $x ?>-panel">

                        <div className="chapter-head-panel clearfix">
                            <div className="pull-left">

                                <h3>
                                    {done &&
                                    <i className={"zmdi zmdi-check chapter-complete"}></i>
                                    }
                                    {i + 1}. {chapter.name || chapter.title}</h3>
                            </div>
                            <div className="pull-right">
                                {chapter.File ? chapter.File.length > 0 &&
                                <div className="sm-top10">
                                    {chapter.File.length > 1 ?
                                        <div className="dropdown pull-right">
                                            <Link
                                                to="#"
                                                className="dropdown-toggle text-red"
                                                data-toggle="dropdown"
                                                role="button"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                            >
                                            <i className="zmdi zmdi-download"></i> &nbsp; 
                                                Chapter Downloads &nbsp;
                                                <span className="caret"/>
                                            </Link>
                                            <ul className="dropdown-menu pull-left">
                                                {chapter.File.map(f => {
                                                    return (
                                                        <li>
                                                            <a href={api.makeFileURL(f.url, this.props.user.id)} target="_blank" download={f.name}>
                                                                {f.name}
                                                            </a>
                                                        </li>
                                                    )
                                                })}

                                            </ul>
                                        </div>

                                        :

                                        <a href={api.makeFileURL(chapter.File[0].url, this.props.user.id)} download={chapter.File[0].name} target="_blank"
                                           className="text-red"><i className="zmdi zmdi-download"></i> &nbsp;
                                           Download PDF</a>
                                    }

                                </div>
                                : null
                                }
                            </div>
                        </div>
                        <div className="videos-slider-wrapper">
                            <div className="chapControlsRight"></div>
                            <div className="videos-slider swiper-container">
                                <div className="swiper-wrapper">
                                    {chapter.type === "test" ?
                                        <div>


                                        <Scrollbars style={{ height: "220px" }} renderThumbHorizontal={this.renderThumb} renderThumbVertical={this.renderThumb}>
                                            <span className="video-item-wrapper">
                                                <div className={`swiper-slide video-item ${(this.state.currentChapter.id === chapter.id) ? "active-video" : "video-locked"}`} onClick={(e) => {
                                                    this.setState({showLectureDetails: chapter, showLecturePartDetails: i});
                                                    this.props.focusLecture(chapter.id, this.props.user.id, this.props.profile.id);
                                                }}>

                                                    {chapter.ChapterPartImage ?
                                                        <a ><img src={api.makeFileURL(chapter.ChapterPartImage.tinyUrl ? chapter.ChapterPartImage.tinyUrl : chapter.ChapterPartImage.url, this.props.user.id)} alt="Video" /> </a>
                                                        :
                                                        <a ><img src={placeholder} alt="Video" /> </a>

                                                    }

                                                    <div className="video-item-name">
                                                        <Link to={(videoClass !== 'video-locked') ? `/subject-test/${chapter.id}` : ``}>{chapter.name}</Link>

                                                        {this.state.currentChapter.id === chapter.id ?
                                                            <Link
                                                                to={(videoClass !== 'video-locked') ? `/subject-test/${chapter.id}` : ``}
                                                                className="btn btn-danger btn-test"
                                                            >Take Test</Link>
                                                            
                                                            :
                                                            null
                                                        }

                                                    </div>



                                                </div>

                                                </span>
                                                </Scrollbars>
                                        </div>
                                        : 
                                        chapter.loading && chapter.ChapterVideo.length === 0?
                                            <Scrollbars style={{ height: "220px", width: "100%" }} renderThumbHorizontal={this.renderThumb} renderThumbVertical={this.renderThumb}>
                                                {this.mapLoadingTiles()}
                                            </Scrollbars>
                                        :
                                        <Scrollbars style={{ height: "220px", width: "100%" }} renderThumbHorizontal={this.renderThumb} renderThumbVertical={this.renderThumb}>
                                        {this.mapChapterVideos(chapter.ChapterVideo.sort(function(a,b) {
                                            return (a.number > b.number) ? 1 : ((b.number > a.number) ? -1 : 0)
                                        }), i, ((currentChapter) ? currentChapter.id === chapter.id : false))}
                                        </Scrollbars>
                                    }
                                </div>
                                {this.props.courseUser[0] &&
                                <div className={(this.props.chapterPart && this.state.showLectureDetails === i) ? "videoDescWrapper open" : "videoDescWrapper"}>
                                    {this.props.chapterPart && (this.props.ul.filter(l => l.chapterVideoId === this.props.chapterPart.id && l.completed && l.active).length > 0 || this.props.courseUser[0].currentChapterPart === this.props.chapterPart.id) ? 
                                    <div className="videoDesc">
                                        <a className="closeDesc" onClick={(e) => this.setState({
                                            showLectureDetails: -1,
                                            showLecturePartDetails: -1
                                        })}><i className="zmdi zmdi-close"></i></a>
                                        <h3>{this.props.chapterPart.title}</h3>
                                        <p className="video-description">{this.props.chapterPart.description}</p>
                                        <div className="row">

                                            {this.props.chapterPart.VideoQuestions &&
                                            <div className="col-sm-4">
                                                <div className="sp-top20">

                                                    {this.props.chapterPart.finish || this.props.chapterPart.VideoQuestions.length > 0 ?
                                                    <div>
                                                        <h2 className="sm-top0 sm-bottom10">Lecture Goals</h2>
                                                        <ul className="list-unstyled lecture-goals">
                                                            {this.props.chapterPart.finish > 0 &&


                                                                <li><i className={(beatLectureTime) ? "zmdi zmdi-check text-green" : "fa fa-exclamation text-orange"}></i> Finish lecture in under {moment.utc(this.props.chapterPart.finish*1000).format('HH:mm:ss')}</li>
                                                            }

                                                            {this.props.chapterPart.VideoQuestions.filter(q => q.name).map(q => {
                                                                let icon = "fa fa-exclamation text-orange";
                                                                let answered = this.props.videoQuestions.filter(v => v.videoQuestionId === q.id && v.correct === true);
                                                                if (answered.length > 0) {
                                                                    icon = "zmdi zmdi-check text-green";
                                                                }

                                                                return (
                                                                    <li><i className={icon}></i> {q.name}</li>
                                                                )
                                                            })}
                                                        </ul>
                                                    </div>
                                                    
                                                    : 
                                                        null
                                                    }


                                                </div>
                                            </div>
                                            }
                                            <div className="col-sm-3">
                                                <div className="sp-top20 text-center">
                                                    <h2 className="sm-top0 sm-bottom10">Merits Earned</h2>
                                                    <h4 className="sm-top-bottom0"
                                                        style={{fontSize: '150px'}}>{this.props.videoQuestions.filter(vq => vq.correct === true).length + points}</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="desc-controls">
                                            {this.props.ul.filter(l => l.chapterVideoId === this.props.chapterPart.id && l.completed && l.active).length > 0
                                                || this.props.courseUser[0].currentChapterPart === this.props.chapterPart.id ?
                                            <Link to={`/video/item/${this.props.chapterPart.id}`}
                                                  className="btn btn-danger btn-block"><i
                                                className="zmdi zmdi-play"></i> Resume</Link>
                                                : null }
                                        </div>
                                    </div>
                                    
                                    :
                                        (this.props.chapterPart) ?
                                            <div className="panel-body no-padding" style={{marginTop: -15, borderWidth: '0px !important', boxShadow: 'none'}}>
                                                        <a className="closeDesc" onClick={(e) => this.setState({
                                                            showLectureDetails: -1,
                                                            showLecturePartDetails: -1
                                                        })}><i className="zmdi zmdi-close"></i></a>
                                                        <div className="alert alert-danger sm-bottom0">
                                                            <h1>Oh Snap! This lecture is still locked.</h1>
                    
                                                            <p className="sm-bottom20">You can't access this lecture because you're currently supposed to be working on your current one.</p>
                                                            <p className="sm-bottom20">For you to score high, we've personalized the order in which you need to complete the content based on your diagnostic score, test dates and instructor feedback!</p>
                    
                    
                                                            <p>#followtheprocess</p>
                                                        </div>
                    
                                                    </div>
                                                    : null
                                    }
                                </div>
                                }
                            </div>




                        </div>
                    </div>
                )
            })
            

        )
    }

    findNextStep(subindex, chapterindex, chapterpartindex){
        let subject = this.props.video.video.CourseSubject[subindex];
        let chapter = subject.CourseChapter[chapterindex];
        let chapterPart = chapter.ChapterVideo[chapterpartindex];

        if(!chapterPart){
            return this.findNextStep(subindex, chapterindex + 1, 0)
        }else if(!chapter){
            return this.findNextStep(subindex + 1, 0, 0);
        }else if(!subject){
            return {type: "completed course"};
        }else{
            let data = {subject: subindex, chapter: chapterindex, chapterpart: chapterpartindex};
            return data;
        }
    }
    
    updateTimer = () => {
        this.setState({timeLeft: this.state.timeLeft - 1, timeTaken: this.state.timeTaken + 1});
    }

    render() {

        let currentVideo = null;
        let currentVideoImage = null;
        let currentChapterLength = 0;
        let {currentUser, currentChapter, currentChapterPart, loaded} = this.state;


        if(!loaded){
            return (
                <div className="loader">
                    <div className="sk-folding-cube">
                        <div className="sk-cube1 sk-cube"></div>
                        <div className="sk-cube2 sk-cube"></div>
                        <div className="sk-cube4 sk-cube"></div>
                        <div className="sk-cube3 sk-cube"></div>
                    </div>
                </div>
            )
        }

        let subject = this.props.userSubject.Subject;


        if(currentUser.status !== 'approved'){
            return (
                <div><h1 className="expired-content">You do not have access to this content.  Please contact your instructor if you feel this is in error.</h1></div>
            )
        }

    

        if(this.state.currentUser && this.state.currentChapter && this.props.userSubject ||
            this.props.userSubject && this.state.completedSubject ||
            this.state.currentUser && this.state.currentChapterTest && this.state.currentChapter
        ) {
            let totalSeconds, minutes, seconds, totalTime, currentPart, chapterSeconds;
            if(!this.state.completedSubject) {
                totalSeconds = 0;
                chapterSeconds = 0;
                this.props.ul.filter(l =>  l.completed && l.active).map(p => {
                    if(p.subjectChapterId === currentChapter.id) {
                        totalSeconds += p.duration;
                    }
                });

                if(this.state.currentUser.currentPartVideoTime){
                    totalSeconds += this.state.currentUser.currentPartVideoTime;
                }
                
                totalTime = moment.utc(this.state.chapterTime*1000).format('HH:mm:ss');

                let currentChapterNumber = parseInt(currentChapter.number) + 1;
                currentPart;
                this.props.userSubject.Subject.CourseChapter.map(chapter => {
                    chapter.ChapterVideo.map(vid => {
                        if(vid.id === currentUser.currentChapterPart){
                            currentPart = vid;
                            //return true;
                        }
                    })
                });

                if(!currentPart){
                    currentPart = this.props.userSubject.Subject.CourseChapter[0].ChapterVideo[0];
                }
                
            }
            let actuallyComplete = this.props.us.filter(s => s.courseSubjectId === this.props.userSubject.id && s.completed);


            if(new Date(currentUser.expiry) < new Date()){
                return (
                    <div><h1 className="expired-content">This content has expired</h1></div>
                )
            }

            

            return (

                <div className="content-wrapper" id="content-container" onClick={e => this.unFocusDetils()}>

                    <section className="content no-padding animated fadeIn">
                    
                        <div className="current-video-summary-wrapper"
                             style={(currentPart) ?
                                currentPart.type === 'test' ?
                                    {background: 'url("' + testBanner + '")'}
                                :
                                currentPart.VideoFile ?
                                currentPart.ChapterPartBanner ?
                                        {background: 'url("' + api.makeFileURL(currentPart.ChapterPartBanner.url, this.props.user.id) + '")'}
                                        :
                                        
                                 (currentPart.ChapterPartImage) ?
                                     {background: 'url("' + api.makeFileURL(currentPart.ChapterPartImage.tinyUrl ? currentPart.ChapterPartImage.tinyUrl : currentPart.ChapterPartImage.url, this.props.user.id) + '")'}
                                     : currentPart.VideoFile ?
                                        currentPart.VideoFile[currentPart.VideoFile.length - 1] ?
                                            currentPart.VideoFile[currentPart.VideoFile.length - 1].thumbnail ?
                                            {background: 'url("' + api.makeFileURL(currentPart.VideoFile[currentPart.VideoFile.length - 1].thumbnail, this.props.user.id) + '")'}
                                            : {background: 'url("' + placeholder + '")'}
                                            : {background: 'url("' + placeholder + '")'}
                                     : {background: 'url("' + placeholder + '")'}
                                     : {background: 'url("' + placeholder + '")'}
                                     : {background: 'url("' + placeholder + '")'}
                             }>
                             <Link to='/dashboard/'>
                                <i className="zmdi zmdi-arrow-left xl-icon" />
                            </Link>

                            {this.state.completedSubject ?
                                <div className="current-video-summary text-grey text-right">
                                    <div className="quick-summary-wrapper sm-bottom20 clearfix">
                                        <div className="pull-right">
                                            <div className="pull-left line-height-1 sm-right10"
                                                 style={{paddingTop: "6px;"}}>
                                                 {this.props.userSubject.completed &&
                                                <h2 className="no-margin font-18 font-700">
                                                    <i className="zmdi zmdi-check text-success"></i> &nbsp;
                                                    Completed on
                                                    {this.props.userSubject.completed ? 

                                                        " " + moment(this.props.userSubject.completedOn).format('MMM DD YYYY')
                                                    : null}
                                                    </h2>
                                                 }

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            :
                                <div className="current-video-summary text-grey text-right">
                                    <div className="quick-summary-wrapper sm-bottom20 clearfix">
                                        <div className="pull-right">
                                            <div className="pull-left line-height-1 sm-right10"
                                                 style={{paddingTop: "6px;"}}>
                                                <h2 className="no-margin font-18 font-700">CH</h2>
                                                <p className="no-margin"><i className="zmdi zmdi-library"></i></p>
                                            </div>
                                            <div className="pull-left">
                                                <h1 className="font-40 font-700">{
                                                    currentUser && currentChapter &&
                                                    `${currentChapter.number + 1}/${this.props.userSubject.Subject.CourseChapter.length}`

                                                }</h1>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="time-elapsed-wrapper sm-bottom20">
                                        <h3 data-toggle="tooltip" data-placement="left"
                                            title="This is the time you've spent on this specific chapter. Your goal is to be as efficient as possible; don't rush but make sure you're taking less time but understanding and memorizing as you go! ">
                                            <span>Time Elapsed</span>
                                                <Counter
                                                    plain={true}
                                                    seconds={this.state.timeTaken}
                                                    direction="up"
                                                    cu={null}
                                                    subject={null}
                                                />
                                            </h3>
                                        <i className="zmdi zmdi-timer font-24"></i>
                                    </div>
                                    {this.props.courseUser[0].currentSubjectDeadline &&
                                    <div className="time-elapsed-wrapper sm-bottom20">
                                        <h3 data-toggle="tooltip" data-placement="left"
                                            title="This is the time you've spent on this specific chapter. Your goal is to be as efficient as possible; don't rush but make sure you're taking less time but understanding and memorizing as you go! ">
                                            <span>Time Remaining</span>
                                            <Counter
                                                plain={true}
                                                seconds={this.state.timeLeft}
                                                direction="down"
                                                cu={null}
                                                subject={null}
                                            />
                                            </h3>
                                        <i className="zmdi zmdi-timer font-24"></i>
                                    </div>
                                    }
                                    <div className="chapters-info-wrapper">
                                        <Scrollbars style={{height: '280px'}} renderThumbHorizontal={this.renderThumb} renderThumbVertical={this.renderThumb}>
                                        <ul>
                                            {currentChapter &&
                                            this.props.userSubject.Subject.CourseChapter.map((v, i) => {
                                                let iconClass, liClass;

                                                let completed = false;
                                                let chapterVideos = v.ChapterVideo;
                                                let completedVideos = [];
                                                v.ChapterVideo.map(vv => {
                                                    if(vv.UserLecture.length > 0){
                                                        completedVideos.push(v);
                                                    }
                                                });

                                                if(chapterVideos.length === completedVideos.length){
                                                    completed = true;
                                                }

                                                if (completed) {
                                                    iconClass = 'zmdi-check-square';
                                                } else if (currentChapter.id === v.id) {
                                                    iconClass = 'zmdi-check-square';
                                                    liClass = 'current-chapter';
                                                } else {
                                                    iconClass = 'zmdi-square-o';
                                                }

                                                return (
                                                    <li className={liClass}>
                                                        <p>{v.name || v.title}
                                                            {(currentUser.currentChapterTime) &&
                                                            <span
                                                                className="font-300"><br/>currentUser.currentChapterTime</span>
                                                            }
                                                        </p>
                                                        <i className={`zmdi ${iconClass}`} data-toggle="tooltip"
                                                           title="Chapter Complete"></i></li>
                                                )
                                            })
                                            }


                                        </ul>
                                        </Scrollbars>
                                    </div>
                                </div>
                            }

                            {!this.state.completedSubject &&
                            currentPart ?
                            currentPart.type === 'test' ?
                                <a className="btn btn-danger begin-test-button" href={'/subject-test/' + currentPart.id}>Begin</a>
                            :
                            
                            
                            <div className="play-btn">
                                <div className="epc-2" data-percent="86"><a
                                    onClick={e => {
                                        e.preventDefault();
                                        
                                        let container =  $(`a[href="/video/item/${(currentPart) ? currentPart.id : ''}"]`).parent();
                                        if(currentPart.type === 'test'){
                                            container = $(`a[href="/subject-test/${(currentPart) ? currentPart.id : ''}"]`).parent();
                                        }
                                        let children = container.find('a[href="*"]');
                                        let ids = [];
                                        
                                        children.each(function(item){
                                            let link = item.attr('href');
                                            if(link.indexOf('/') > -1){
                                                let splitted = link.split('item/')[1];
                                                ids.push(splitted);
                                            }
                                        });
                                        
                                        let idIndex = ids.indexOf((currentChapterPart) ? currentChapterPart.id : '');
                                        
                                        container.animate({scrollLeft:'+=' + (200 * (idIndex + 1))},500);
                                        
                                        if(currentPart.type === 'test'){
                                            $('html, body').animate({
                                                scrollTop: $(`a[href="/subject-test/${(currentPart) ? currentPart.id : ''}"]`).offset().top - 60 + 'px'
                                            }, 'fast');
                                            $(`a[href="/video/item/${(currentPart) ? currentPart.id : ''}"]`).parent().trigger('click');
                                        }else{
                                            $('html, body').animate({
                                                scrollTop: $(`a[href="/video/item/${(currentPart) ? currentPart.id : ''}"]`).offset().top - 60 + 'px'
                                            }, 'fast');
                                            $(`a[href="/video/item/${(currentPart) ? currentPart.id : ''}"]`).parent().trigger('click');
                                        }
                                    }}
                                    ><i
                                    className="zmdi zmdi-play-circle"></i>
                                    {currentPart ? 
                                        currentPart.type !== "test" &&
                                        <PieChart
                                            style={{width: 81, margin: '0 auto', marginTop: '28px'}}
                                            data={[
                                                {value: currentPart.UserLecture.length > 0 ? currentPart.UserLecture[0].duration ? currentPart.UserLecture[0].duration : 100 : 100, color: '#555'},
                                                {value: currentPart.UserLecture.length > 0 ? currentPart.UserLecture[0].currentTime : 0, color: '#e33339'}
                                            ]}
                                            totalValue={currentPart.UserLecture.length > 0 ? currentPart.UserLecture[0].duration : 100}
                                            lineWidth={20}
                                            startAngle={-90}
                                            rounded={true}
                                        />
                                        : null
                                    }

                                </a></div>
                            </div>
                            :
                             null
                            }
                            <div className="summary-chapter-title">
                                {currentPart ?
                                    currentPart.type === 'test' ?
                                    <h1 className="font-300">{(currentPart.name) ? currentPart.name : currentPart.title}</h1>
                                    :
                                    <h1 className="font-300">{(currentPart) ? (currentPart.name) ? currentPart.name : currentPart.title : ''}</h1>
                                    : null
                                }
                            </div>
                        </div>

                        <div className=" sp-20">
                            <div className="row">
                                <div className="col-sm-12">

                                    {
                                        this.props.userSubject &&
                                        this.mapChapterParts(this.props.userSubject)}

                                </div>

                            </div>
                        </div>
                    </section>
                </div>



            )
        }else{
            return (
                <div>...</div>
            )
        }



    }
}

Video.propTypes = {
    videoGallery: PropTypes.array.isRequired,
    videoDescription: PropTypes.object.isRequired,
    onLoad: PropTypes.func.isRequired,
    userSubject: PropTypes.object.isRequired
};

export default Video;


// WEBPACK FOOTER //
// ./src/components/Video/Video.js